export const retailerLogos = {
	1: {
		id: 1,
		name: 'Meijer',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/meijer-360-105.png',
	},
	3: {
		id: 3,
		name: "Albertson's",
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/albertsons-logo-360-105.png',
	},
	8: {
		id: 8,
		name: 'Publix',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/publix-logo-360-105.png',
	},
	18: {
		id: 18,
		name: 'Dillons',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/dillons-logo-360-105.png',
	},
	20: {
		id: 20,
		name: 'Food 4 Less',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/food-4-less-logo-360-105.png',
	},
	65: {
		id: 65,
		name: "Pick 'n Save",
		imageUrl:
			'https://cdn.groceryserver.com/chain/pick-n-save-logo-360-105-v2.png',
	},
	71: {
		id: 71,
		name: "Shaw's",
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/shaws-logo-360-105.png',
	},
	73: {
		id: 73,
		name: 'Jewel-Osco',
		imageUrl:
			'https://cdn.groceryserver.com/images/jewel-osco-logo-360-105-v2.png',
	},
	74: {
		id: 74,
		name: "Lowe's",
		imageUrl:
			'https://cdn.groceryserver.com/images/lowes-logo-360-105360.png',
	},
	84: {
		id: 84,
		name: 'Fred Meyer',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/fred-meyer-logo-360-105.png',
	},
	112: {
		id: 112,
		name: 'Safeway',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/safeway-logo-360-105.png',
	},
	122: {
		id: 122,
		name: 'Jay C Foods',
		imageUrl: 'https://cdn.groceryserver.com/images/Jay-C-Foods.png',
	},
	123: {
		id: 123,
		name: 'Food Lion',
		imageUrl:
			'https://cdn.groceryserver.com/images/food-lion-logo-360-105-v2.png',
	},
	140: {
		id: 140,
		name: "Fry's Food \u0026 Drug",
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/frys-food-drug-logo-360-105.png',
	},
	147: {
		id: 147,
		name: 'QFC',
		imageUrl: 'https://cdn.groceryserver.com/images/qfc-logo-360-105.png',
	},
	156: {
		id: 156,
		name: 'King Soopers',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/king-soopers-logo-360-105.png',
	},
	167: {
		id: 167,
		name: "Smith's Food \u0026 Drug",
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/smithsfoodanddrug-logo-360-105.png',
	},
	180: {
		id: 180,
		name: "Baker's",
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/bakers-logo-360-105.png',
	},
	182: {
		id: 182,
		name: 'Kroger',
		imageUrl:
			'https://cdn.groceryserver.com/images/kroger-new-logo-360-105.png',
	},
	224: {
		id: 224,
		name: 'Pavilions',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/pavillions-logo-360-105.png',
	},
	242: {
		id: 242,
		name: 'Randalls',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/randalls-logo-360-105.png',
	},
	264: {
		id: 264,
		name: 'Harris Teeter',
		imageUrl:
			'https://cdn.groceryserver.com/images/harris-teeter-logo-360-105-v3.png',
	},
	276: {
		id: 276,
		name: 'Walmart',
		imageUrl: 'https://cdn.groceryserver.com/chain/walmart-360-105.png',
	},
	318: {
		id: 318,
		name: 'CVS',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/cvs-logo-360-150.png',
	},
	339: {
		id: 339,
		name: 'Target',
		imageUrl:
			'https://cdn.groceryserver.com/images/target-logo-350-116.png',
	},
	342: {
		id: 342,
		name: 'Ralphs',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/ralphs-logo-360-105.png',
	},
	343: {
		id: 343,
		name: 'Vons',
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/vons-logo-360-105.png',
	},
	361: {
		id: 361,
		name: "Mariano's Fresh Market",
		imageUrl:
			'https://cdn.groceryserver.com/images/chain/marianos-fresh-logo-360-105-2.png',
	},
	380: {
		id: 380,
		name: 'Gerbes',
		imageUrl:
			'https://cdn.groceryserver.com/chain/gerbes-super-markets-logo-360-105-v3.png',
	},
	385: {
		id: 385,
		name: 'City Market',
		imageUrl:
			'https://cdn.groceryserver.com/chain/city-market-logo-360-105.png',
	},
	460: {
		id: 460,
		name: 'Whole Foods Market',
		imageUrl:
			'https://cdn.groceryserver.com/images/whole-foods-logo-350-116.png',
	},
	511: {
		id: 511,
		name: 'AmazonFresh',
		imageUrl:
			'https://cdn.groceryserver.com/images/amazonfresh-logo-360-105-v3.png',
	},
	547: {
		id: 547,
		name: 'Metro Market',
		imageUrl:
			'https://cdn.groceryserver.com/images/metro-market-logo-360-105.png',
	},
	549: {
		id: 549,
		name: 'Total Wine \u0026 More',
		imageUrl:
			'https://cdn.groceryserver.com/images/total-wine-logo-360-105.png',
	},
};
